import {useTranslation} from "@Translation/hooks/useTranslation";
import {activateDepartureStationInput, activateDestinationStationInput} from "@Reducers/mobileSlice";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";
import getFormVersionClassNameAggregator from "@Form/functions/getFormVersionClassNameAggregator";
import {FormVersionType} from "@Form/types/FormVersion.type";

/**
 * Returns relevant input methods and props based on direction
 */
export default function useMobileStationInput(direction: "departure" | "destination", formVersion: FormVersionType) {
    const {
        departureStationObject,
        destinationStationObject,
    } = useAppSelector((state) => state?.form)

    const {v} = getFormVersionClassNameAggregator(formVersion)
    const departureStationPlaceholder = useTranslation("form.departure.placeholder")
    const destinationStationPlaceholder = useTranslation("form.destination.placeholder")
    const dispatch = useAppDispatch()
    const isDeparture = direction === 'departure'
    const directionLabel = isDeparture ? 'form.departure.label' : 'form.destination.label'
    const station = isDeparture ? departureStationObject : destinationStationObject
    const placeholder = isDeparture ? departureStationPlaceholder : destinationStationPlaceholder
    const className = isDeparture
        ? `gb--search${v()}__select gb--search${v()}__select--from`
        : `gb--search${v()}__select gb--search${v()}__select--to`

    const onClick = () => {
        dispatch(isDeparture
            ? activateDepartureStationInput(true)
            : activateDestinationStationInput(true))
    }

    return {
        isDeparture,
        directionLabel,
        station,
        className,
        placeholder,
        onClick,
    }
}